import { Routes, Route, Navigate } from 'react-router-dom';
import ErrorBoundary from '../components/ErrorBoundary';
import StockTransfer from '../pages/StockTransfer';
import POExpenses from '../pages/POExpenses';
import GroupAbsenceCalendar from '../pages/GroupAbsenceCalendar';
import TransportUIGate from '../components/TransportUIGate';
import PICountsWarehouse from '../pages/PICountsWarehouse';
import GoodsInWarehouse from '../pages/GoodsInWarehouse';
import Settings from '../pages/Settings';
import LimitedShell from './LimitedShell';
import LimitedHome from './LimitedHome';
import { LIMITED_PAGES } from './limitedPages';

// The whole route table for a user on the Limited Access UI. Anything not listed here sends them
// back to the limited home, so a limited user can never land on a full-dashboard page by URL.
// To roll another page out: register it in limitedPages.js and add its <Route> below.
const LimitedRoutes = ({ user, onLogout, onUserUpdate, onImpersonate }) => {
  const canAccessPage = (id) => {
    const page = LIMITED_PAGES.find((p) => p.id === id);
    return !!page && page.canAccess(user);
  };
  const canStockTransfer = canAccessPage('stock-transfer');
  const canPoExpenses = canAccessPage('po-expenses');
  const canAnnualLeave = canAccessPage('annual-leave');
  const canTransport = canAccessPage('transport');
  const canPiCountsWarehouse = canAccessPage('pi-counts-warehouse');
  const canGoodsInWarehouse = canAccessPage('goods-in-warehouse');
  const canSettings = !!user && (user.role === 'super_admin' || !!user.can_access_settings);

  return (
    <LimitedShell user={user} onLogout={onLogout}>
      <Routes>
        <Route
          path="/limited"
          element={<ErrorBoundary><LimitedHome user={user} /></ErrorBoundary>}
        />
        <Route
          path="/stock-transfer"
          element={canStockTransfer
            ? <ErrorBoundary><StockTransfer user={user} /></ErrorBoundary>
            : <Navigate to="/limited" replace />}
        />
        <Route
          path="/stock-transfer/:transferId"
          element={canStockTransfer
            ? <ErrorBoundary><StockTransfer user={user} /></ErrorBoundary>
            : <Navigate to="/limited" replace />}
        />
        <Route
          path="/po-expenses"
          element={canPoExpenses
            ? <ErrorBoundary><POExpenses user={user} /></ErrorBoundary>
            : <Navigate to="/limited" replace />}
        />
        <Route
          path="/group-absence-calendar"
          element={canAnnualLeave
            ? <ErrorBoundary><GroupAbsenceCalendar user={user} onLogout={onLogout} /></ErrorBoundary>
            : <Navigate to="/limited" replace />}
        />
        <Route
          path="/transport"
          element={canTransport
            ? <ErrorBoundary><TransportUIGate user={user} onLogout={onLogout} /></ErrorBoundary>
            : <Navigate to="/limited" replace />}
        />
        <Route
          path="/pi-counts-warehouse"
          element={canPiCountsWarehouse
            ? <ErrorBoundary><PICountsWarehouse user={user} /></ErrorBoundary>
            : <Navigate to="/limited" replace />}
        />
        <Route
          path="/goods-in-warehouse"
          element={canGoodsInWarehouse
            ? <ErrorBoundary><GoodsInWarehouse user={user} /></ErrorBoundary>
            : <Navigate to="/limited" replace />}
        />
        <Route
          path="/settings"
          element={canSettings
            ? <Settings user={user} onUserUpdate={onUserUpdate} onImpersonate={onImpersonate} />
            : <Navigate to="/limited" replace />}
        />
        <Route path="*" element={<Navigate to="/limited" replace />} />
      </Routes>
    </LimitedShell>
  );
};

export default LimitedRoutes;
